'use client';

import { useMapsConfigContext } from '@/contexts/MapsConfigContext';

export interface MapsConfig {
  api_key: string | null;
  map_id: string | null;
}

export interface UseMapsConfigReturn {
  api_key: string | null;
  map_id: string | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Google Maps API key: MapsConfigProvider üzerinden (layout'ta tek sefer çekilir veya provider client'ta tek istek atar).
 * ProductTourDetail, ContactGoogleMap, TourRouteMap vb. bu hook ile key alır; duplicate istek atılmaz.
 */
export function useMapsConfig(): UseMapsConfigReturn {
  const ctx = useMapsConfigContext();
  return {
    api_key: ctx.api_key,
    map_id: ctx.map_id,
    isLoading: ctx.isLoading,
    error: ctx.error,
    refetch: ctx.refetch,
  };
}
